import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ContractChangesComponent } from "@app/views/contract-changes/contract-changes.component";
import { ContractDetailContractInformationsComponent } from "@app/views/contract-detail-sa-contract-informations/contract-detail-sa-contract-informations.component";
import { ContractEditionIbanComponent } from "@app/views/contract-edition-iban/contract-edition-iban.component";
import { ContractEditionPaymentInformationsComponent } from "@app/views/contract-edition-payment-informations/contract-edition-payment-informations.component";
import { LessorDialogComponent } from "@app/views/lessor-edition-modal/lessor-dialog.component";
import { OkDialogComponent } from "@app/views/ok-dialog-component/ok-dialog.component";
import { PersonalDataComponent } from "@app/views/personal-data/personal-data.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ContractEditionChildrenMrhComponent } from "@shared/components/offers/MRH/contract-edition-children-mrh/contract-edition-children-mrh.component";
import { ContractEditionForOptTarifMrhComponent } from "@shared/components/offers/MRH/contract-edition-foropttarif-mrh/contract-edition-foropttarif-mrh.component";
import { ContractEditionHousingMrhComponent } from "@shared/components/offers/MRH/contract-edition-housing-mrh/contract-edition-housing-mrh";
import { ContractEditionLessorMrhComponent } from "@shared/components/offers/MRH/contract-edition-lessor-mrh/contract-edition-lessor-mrh.component";
import { Formula, getFormulaBy, getFormulasBy } from "@shared/constants/formula.constants";
import { ONLY_CHAR_VALIDATOR_REGEX } from "@shared/constants/validator.constants";
import { Bank } from "@shared/enums/bank-type.enum";
import { ClientFields } from "@shared/enums/client-fields.enum";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { ForOptTarif } from "@shared/enums/foropttarif.enum";
import { FractionationTypes } from "@shared/enums/fractionation-types";
import { HttpErrors } from "@shared/enums/http-errors-type.enum";
import { LessorType } from "@shared/enums/lessorType";
import { OptionalService } from "@shared/enums/optional-service.enum";
import { PackagesLabelType } from "@shared/enums/packages-label-type";
import { PackagesType } from "@shared/enums/packages-type";
import { PolicyFields } from "@shared/enums/policy-fields.enum";
import { RiskItemInformations } from "@shared/enums/riskItemInformations";
import { IbanValidator } from "@shared/helpers/contract-edition.helper";
import { convertDateToUTC } from "@shared/helpers/date.helper";
import { Country } from "@shared/models/country";
import { LessorList } from "@shared/models/lessor";
import { Member } from "@shared/models/member";
import { PhonePrefixes } from "@shared/models/phone-prefixes";
import { PolicyChangeLog } from "@shared/models/policy-change-log.model";
import { LessorDataDto, PolicyDetail, RiskItemInformationsVm } from "@shared/models/policy-details";
import { PolicyFieldsVM, PolicyFieldVM } from "@shared/models/policy-field-vm.model";
import { ComputePolicyUpdateCommand, UpdatePolicyCommand } from "@shared/models/policy-update-command.model";
import { CountryService } from "@shared/services/country.service";
import { LessorService } from "@shared/services/lessor.service";
import { MembersService } from "@shared/services/members.service";
import { PhonePrefixesService } from "@shared/services/phone-prefixes.service";
import { PolicyRecoveryService } from "@shared/services/policy-recovery.service";
import { PolicyService } from "@shared/services/policy.service";
import { Guid } from "guid-typescript";
import { DateTime } from "luxon";
import _ from "lodash";
import { MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { InputMaskModule } from "primeng/inputmask";
import { StepperModule } from "primeng/stepper";
import { StepsModule } from "primeng/steps";
import { fromDateTimeToDateOnly } from "@shared/helpers/date.helper";

@Component({
  selector: "app-contract-edition",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    DropdownModule,
    ButtonModule,
    StepperModule,
    StepsModule,
    TranslateModule,
    CalendarModule,
    InputMaskModule,
    ReactiveFormsModule,
    LessorDialogComponent,
    ContractChangesComponent,
    ContractEditionIbanComponent,
    OkDialogComponent,
    ContractEditionHousingMrhComponent,
    PersonalDataComponent,
    ContractEditionForOptTarifMrhComponent,
    ContractEditionLessorMrhComponent,
    ContractEditionChildrenMrhComponent,
    ContractEditionPaymentInformationsComponent,
    ContractDetailContractInformationsComponent,
  ],
  templateUrl: "./contract-edition.component.html",
  styles: [],
})
export class ContractEditionComponent implements OnInit {
  @Input() policyId!: Guid;
  @Input() visibleDialog!: boolean;
  @Input() editPersonnalData!: boolean;
  @Input() policyDetails!: PolicyDetail;
  @Input() lessorData!: LessorDataDto;
  @Input() isMrhBranch!: boolean;
  @Input() isSaBranch!: boolean;
  @Output() dialogEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() emitUpdateValidation: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(ContractEditionForOptTarifMrhComponent) forOptTarifComponent!: ContractEditionForOptTarifMrhComponent;
  @ViewChild(ContractEditionHousingMrhComponent) housingComponent!: ContractEditionHousingMrhComponent;
  @ViewChild(ContractEditionChildrenMrhComponent) childrenComponent!: ContractEditionChildrenMrhComponent;
  @ViewChild(ContractEditionLessorMrhComponent) lessorComponent!: ContractEditionLessorMrhComponent;
  @ViewChild(ContractEditionPaymentInformationsComponent)
  paymentComponent!: ContractEditionPaymentInformationsComponent;
  @ViewChild(PersonalDataComponent) personalDataComponent!: PersonalDataComponent;
  @ViewChild(ContractDetailContractInformationsComponent)
  contractSADetailComponent!: ContractDetailContractInformationsComponent;

  forOptHasChanged = false;
  housingHasChanged = false;
  childrenHasChanged = false;
  lessorHasChanged = false;
  paymentHasChanged = false;
  personalDataHasChanged = false;

  visibleLessorDialog = false;
  lessorSocialSelected = false;

  policyFieldsVM!: PolicyFieldsVM;
  forOptTarifFields!: PolicyFieldVM[];
  member!: Member;
  policyChangeLog!: PolicyChangeLog;

  ClientFields = ClientFields;
  PolicyFields = PolicyFields;
  ForOptTarif = ForOptTarif;
  OptionalService = OptionalService;
  LessorType = LessorType;
  Bank = Bank;

  activeIndex = 0;
  previousStep = 0;
  maxIndex = 2;

  isLessorDialogVisible = false;
  isIbanDialogVisible = false;
  isIbanErrorDialogVisible = false;
  IsIbanInvalidDialogVisible = false;
  displaySignaturePhone = false;
  isInitPhonePrefix = true;
  phoneNumberHasChanged = false;
  phonePrefixHasChanged = false;
  hasEndorsementWait4Sign = false;

  memberCopy!: Member;
  policyDetailsCopy!: PolicyDetail;
  lessorDataCopy!: LessorDataDto;

  options = FormulasOptions;
  riskItemInfo = RiskItemInformations;
  package = PackagesType;

  natureLogement!: string | undefined;
  qualiteOccupant!: string | undefined;
  possedeVeranda!: string | undefined;
  possedeEnergieV!: string | undefined;
  possedePiscine!: string | undefined;
  typeHabitation!: string | undefined;
  nombrePieces!: string | undefined;
  nombrePiecesQuarante!: string | undefined;
  surfaceDependance!: string | undefined;
  etage!: string;
  identificationNumber!: string | undefined;

  phoneMask!: string;
  possedeVerandaHasChanged = false;
  possedeEnergieVHasChanged = false;
  possedePiscineHasChanged = false;
  riskItemsStatesChanged = new Map<string, boolean>();
  policyZipCodeHasChanged = false;
  annualPremiumHasChanged = false;
  quarterlyPremiumHasChanged = false;
  monthlyPremiumHasChanged = false;
  houseIsOccupedHasChanged = false;
  referenceClientHasChanged = false;
  localPrincipalHasChanged = false;
  contractDetailHasChanged = false;
  bailleurHasChanged = false;
  pjOptionsHasChanged = false;
  vanOptionsHasChanged = false;

  isVANSelected: boolean | undefined;
  isPjSelected: boolean | undefined;
  isSchoolInsuranceSelected: boolean | undefined;
  childFirstNameHasChanged: boolean[] = [];
  childLastNameHasChanged: boolean[] = [];
  childBirthDateHasChanged: boolean[] = [];

  lessorDataNameInitialValue = "";
  lessorDataName!: string;
  lessorList!: LessorList;
  lessorOptions!: string[];

  selectedPhonePrefix!: PhonePrefixes | undefined;
  selectedSignaturePhonePrefix!: PhonePrefixes;
  selectedSignaturePhoneNumber!: string;
  savePhone = false;
  selectedPhoneMask!: string;
  readonly defaultCountry = "France";

  showPhoneError = false;
  applyToAllMyContracts = false;
  hasMemberMultipleReferences = false;
  isConfort = false;
  loading = false;

  birthCountryId!: number;
  nationalityId!: number;

  childrenInformationsInitialValue: RiskItemInformationsVm[] = [];
  childrenInformations: RiskItemInformationsVm[] = [];
  phonePrefixes!: PhonePrefixes[];
  countriesOptions: Country[] = [];

  falseTrueValues: { label: string; value: string }[] = [
    { label: "Non", value: "False" },
    { label: "Oui", value: "True" },
  ];

  fractionationOptions = [
    { label: "Mensuel", value: FractionationTypes.M, code: "Mensuel" },
    { label: "Annuel", value: FractionationTypes.A, code: "Annuel" },
  ];

  isFormValid: boolean[] = [true, true, true];
  IsCallInErrorDialogVisible = false;
  IsSaveDialogVisible = false;
  contratTarget = "contrat";

  steps: { lblValidationButton: string; lblCancelButton: string }[] = [
    {
      lblValidationButton: this.translate.instant("common.next"),
      lblCancelButton: this.translate.instant("common.cancel"),
    },
    {
      lblValidationButton: this.translate.instant("common.next"),
      lblCancelButton: this.translate.instant("common.previous"),
    },
    {
      lblValidationButton: this.translate.instant("common.validate"),
      lblCancelButton: this.translate.instant("common.previous"),
    },
  ];

  constructor(
    private readonly memberService: MembersService,
    private readonly policyService: PolicyService,
    private readonly lessorService: LessorService,
    private readonly phonePrefixesService: PhonePrefixesService,
    private readonly policyRecoveryService: PolicyRecoveryService,
    private readonly countryService: CountryService,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.policyDetailsCopy = structuredClone(this.policyDetails);

    this.setMemberInformations();
    this.setLessorValues();
    this.setPolicyFields();
    this.setChildrenInformations();
    this.setRiskItemsValues();
    this.setPaymentValues();
    this.setCountries();
    this.setHasEndorsementWait4Sign();
    this.isConfort =
      this.policyDetailsCopy.formulasAndOptionsInformations.formulaName === PackagesLabelType.Confort ||
      this.policyDetailsCopy.formulasAndOptionsInformations.formulaName === PackagesLabelType.ConfortPlus;
    this.initCurrentFormula();
  }

  formula: Formula | undefined;
  formulaValues: Formula[] = [];

  private initCurrentFormula() {
    this.formula = getFormulaBy(f => f.id === this.policyDetailsCopy.formulasAndOptionsInformations.formulaId);
    if (!this.formula) {
      this.messageService.add({
        severity: "error",
        summary: this.translate.instant("common.errorMessageTitle"),
        detail: this.translate.instant("common.errorFormula"),
      });
      console.error("Edition du contrat - Formule non trouvée");
      return undefined;
    }
    // Set FormulaValue to provide the dropdown list
    if (this.isConfort) {
      this.formulaValues = getFormulasBy(f => f.code === PackagesType.Confort || f.code === PackagesType.ConfortPlus);
    } else {
      this.formulaValues.push(this.formula);
    }
  }

  setHasEndorsementWait4Sign() {
    this.policyService.getPolicyWait4SignEndorsement().subscribe({
      next: policies => {
        this.hasEndorsementWait4Sign = policies.length > 0;
      },
    });
  }

  getCancelButtonLabel() {
    return this.steps[this.getCurrentStep(this.activeIndex)].lblCancelButton;
  }

  getContractLabel() {
    return this.steps[this.getCurrentStep(this.activeIndex)].lblValidationButton;
  }

  setCountries() {
    this.countryService.getCountries().subscribe(data => {
      this.countriesOptions = data;
    });
  }

  setMemberInformations() {
    this.memberService.getMemberInformations().subscribe(data => {
      this.member = data;
      this.selectedSignaturePhoneNumber = this.member.phoneNumber;
      const parsedMember = structuredClone(this.member);
      if (parsedMember.birthDate) {
        parsedMember.birthDate = new Date(parsedMember.birthDate);
      }
      this.memberCopy = parsedMember;
      this.memberService.getMemberReferences(this.memberCopy.id).subscribe(result => {
        this.hasMemberMultipleReferences = result.filter(x => x.target === this.contratTarget).length > 1;
      });
      this.setPhonePrefixes();
    });
  }

  setLessorValues() {
    if (!this.lessorData) {
      this.lessorSocialSelected = true;
    } else {
      this.lessorSocialSelected = this.lessorDataCopy?.lessorType === LessorType.Social;
    }
    this.lessorDataCopy = structuredClone(this.lessorData);
    this.lessorService.getLessors(this.policyDetailsCopy.productCode).subscribe(data => {
      this.lessorList = data;
      this.lessorOptions = this.lessorList.map(x => x.name);
      this.lessorOptions.push("Autre");
    });
  }

  setPhonePrefixes() {
    this.phonePrefixesService.getPhonePrefixes().subscribe(data => {
      this.phonePrefixes = data;
      this.selectedPhonePrefix = this.phonePrefixes.find(x => x.prefix === this.member.phonePrefix);
      this.selectedSignaturePhonePrefix =
        this.phonePrefixes.find(x => x.prefix === this.member.phonePrefix) || this.phonePrefixes[0];
    });
  }

  setPolicyFields() {
    this.policyService.getPolicyFields(this.policyId).subscribe(data => {
      this.policyFieldsVM = data;
    });
  }

  setPaymentValues() {
    const isTrimestriel =
      this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel.localeCompare("Trimestriel", undefined, {
        sensitivity: "base",
      }) === 0;
    if (isTrimestriel) {
      this.fractionationOptions.push({ label: "Trimestriel", value: FractionationTypes.T, code: "Trimestriel" });
    }
  }

  setRiskItemsValues() {
    this.childFirstNameHasChanged = Array.from({ length: this.childrenInformations.length }, () => false);
    this.childLastNameHasChanged = Array.from({ length: this.childrenInformations.length }, () => false);
    this.childBirthDateHasChanged = Array.from({ length: this.childrenInformations.length }, () => false);
    this.possedePiscine = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.POSSEDE_PISCINE
    )?.value;
    this.natureLogement = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.NATURE_LOG
    )?.value;
    this.possedeEnergieV = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.POSSEDE_ENERGIEV
    )?.value;
    this.qualiteOccupant = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.NATURE_OCCU
    )?.value;
    this.typeHabitation = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.HAB_TYPE
    )?.value;
    this.nombrePieces = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.NBR_PIECES
    )?.value;
    this.possedeVeranda = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.POSSEDE_VERANDA
    )?.value;
    this.nombrePiecesQuarante = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.NBR_PIECES_40M2
    )?.value;
    this.surfaceDependance = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.SURFACE_DEP
    )?.value;

    if(this.policyDetails.productCode === "HC" || this.policyDetails.productCode === "SA" && this.policyDetails.formulasAndOptionsInformations.options.find( x => x.type === this.options.PJ)?.isSelected ){
      this.isPjSelected = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
        x => x.type === this.options.PJ
      )?.isSelected;
    }

    if(this.policyDetails.productCode === "HC" || this.policyDetails.productCode === "SA" && this.policyDetails.formulasAndOptionsInformations.options.find( x => x.type === this.options.VAN)?.isSelected ){
      this.isVANSelected = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
        x => x.type === this.options.VAN
      )?.isSelected;
    }

    this.identificationNumber = this.policyDetailsCopy.riskItemInformations.values.find(
      x => x.code === this.riskItemInfo.ANIMAL_ID
    )?.value;

    const etage = this.policyDetailsCopy.riskItemInformations.values.find(x => x.code === this.riskItemInfo.ADR_ETAGE);
    if (etage) {
      this.etage = etage.value;
    }
  }

  setChildrenInformations() {
    const childrenInformations = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.RCS
    )?.riskItemValues;
    if (childrenInformations) {
      this.childrenInformations = childrenInformations;
      this.reorderChildrenInformations();
      this.childrenInformationsInitialValue = structuredClone(childrenInformations);
    }
    this.isSchoolInsuranceSelected = this.childrenInformations.length > 0;
  }

  setChildrenInformationsToInitial() {
    const initialChildrenValues = structuredClone(this.childrenInformationsInitialValue);
    this.updateChildrenInformation(initialChildrenValues);
  }

  reorderChildrenInformations() {
    const order = [
      ForOptTarif.PRENOM_ENFANT as string,
      ForOptTarif.NOM_ENFANT as string,
      ForOptTarif.DATE_ENFANT as string,
    ];

    return this.childrenInformations.map(item => {
      item.values.sort((a, b) => order.indexOf(a.code) - order.indexOf(b.code));
      return item;
    });
  }

  onIsSchoolInsuranceSelected(event: boolean) {
    this.isSchoolInsuranceSelected = event;
    if (this.isSchoolInsuranceSelected && this.childrenInformations.length === 0) {
      this.childrenComponent.addChild();
    }
    if (!this.isSchoolInsuranceSelected) {
      this.setChildrenInformationsToInitial();
      this.setIsFormValid(0);
    }
  }


  onIsJuridicProtectionSelected(event: boolean) {
    this.isPjSelected = event;
  }

  onIsNewValueOptionSelected(event: boolean) {
    this.isVANSelected = event;
  }

  onIsLessorDialogVisible(event: boolean) {
    this.isLessorDialogVisible = event;
  }

  onAnnualPremiumChange() {
    this.annualPremiumHasChanged =
      this.policyDetails.formulasAndOptionsInformations.annualPremiumTTC !==
      this.policyDetailsCopy.formulasAndOptionsInformations.annualPremiumTTC;
  }

  onMontlyPremiumChange() {
    this.monthlyPremiumHasChanged =
      this.policyDetails.formulasAndOptionsInformations.monthlyPremiumTTC !==
      this.policyDetailsCopy.formulasAndOptionsInformations.monthlyPremiumTTC;
  }

  onQuaryerlyPremiumChange() {
    this.quarterlyPremiumHasChanged =
      this.policyDetails.formulasAndOptionsInformations.quarterPremiumTTC !==
      this.policyDetailsCopy.formulasAndOptionsInformations.quarterPremiumTTC;
  }

  onFormulaChange(capitalMobilier: string) {
    this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[0].value = capitalMobilier;
    this.updateCapitalMobilierAndValuableObject();
  }

  setIsFormValid(step: number) {
    const currentStep = this.getCurrentStep(step);

    //Policy
    if (step === 0) {
      const isLessorDataValid =
        !this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption ||
        (this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
          this.lessorSocialSelected &&
          this.lessorDataCopy.ref1 !== "" &&
          this.lessorDataCopy.ref2 !== "") ||
        (this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
          !this.lessorSocialSelected &&
          this.lessorDataCopy.email !== "");
      this.isFormValid[currentStep] =
        !this.childrenInformations.some(
          x => x.values.find(x => x.code === this.ForOptTarif.PRENOM_ENFANT)!.value === ""
        ) &&
        !this.childrenInformations.some(
          x => x.values.find(y => y.code === this.ForOptTarif.NOM_ENFANT)!.value === ""
        ) &&
        !this.childrenInformations.some(
          x =>
            x.values.find(z => z.code === this.ForOptTarif.DATE_ENFANT)!.value === "" ||
            x.values.find(z => z.code === this.ForOptTarif.DATE_ENFANT)!.value === null
        ) &&
        this.policyDetailsCopy.bankInformationPolicyVm.iban !== "" &&
        IbanValidator(this.policyDetailsCopy.bankInformationPolicyVm.iban) &&
        isLessorDataValid;
    }

    //Personnal
    if (step === 1) {
      this.isFormValid[currentStep] =
        (this.memberCopy.phoneNumber === "" ||
          (this.memberCopy.phoneNumber !== "" &&
            this.memberCopy.phoneNumber.length === this.phoneMask.replace(/\s/g, "").length)) &&
        this.memberCopy.firstName !== "" &&
        ONLY_CHAR_VALIDATOR_REGEX.test(this.memberCopy.firstName) &&
        this.memberCopy.lastName !== "" &&
        ONLY_CHAR_VALIDATOR_REGEX.test(this.memberCopy.lastName) &&
        this.memberCopy.birthCity !== "" &&
        this.memberCopy.birthCountry !== "" &&
        this.memberCopy.zipCode !== "" &&
        this.memberCopy.address1 !== "" &&
        this.memberCopy.zipCode !== "" &&
        this.memberCopy.addressCity !== "" &&
        this.memberCopy.birthDate !== null;
    }

    //Changes
    if (step === 2) {
      this.isFormValid[currentStep] = this.displaySignaturePhone
        ? this.selectedSignaturePhonePrefix !== null &&
          this.selectedSignaturePhoneNumber !== null &&
          this.selectedSignaturePhoneNumber !== "" &&
          this.selectedSignaturePhoneNumber.length === this.selectedPhoneMask.replace(/\s/g, "").length
        : true;
    }
  }

  getCurrentStep(step: number) {
    if (step === 0) {
      return 0;
    }
    return this.editPersonnalData ? step : step - 1;
  }

  hasChanged() {
    this.checkForOptTarifChanged();
    this.checkHousingChanged();
    this.checkChildrenChanged();
    this.checkLessorChanged();
    this.checkPaymentChanged();
    this.checkPersonalDataChanged();
    this.checkForAnimalInsuranceChanged();
    return (
      this.forOptHasChanged ||
      this.housingHasChanged ||
      this.childrenHasChanged ||
      this.lessorHasChanged ||
      this.paymentHasChanged ||
      this.personalDataHasChanged ||
      this.contractDetailHasChanged ||
      this.pjOptionsHasChanged ||
      this.vanOptionsHasChanged
    );
  }

  checkForAnimalInsuranceChanged() {
    if (this.contractSADetailComponent) {
      this.contractDetailHasChanged =
        this.contractSADetailComponent?.contractFormGroup.controls.identificationNumber.dirty;
    }
  }

  checkForOptTarifChanged() {
    if (this.forOptTarifComponent) {
      this.forOptHasChanged =
        this.forOptTarifComponent?.PJSOLHasChanged ||
        this.forOptTarifComponent?.RCSHasChanged ||
        this.forOptTarifComponent?.formulaHasChanged ||
        this.forOptTarifComponent?.bailleurHasChanged ||
        this.forOptTarifComponent?.capMobHasChanged ||
        this.forOptTarifComponent?.valuableObjectHasChanged;
    }
  }

  checkHousingChanged() {
    if (this.housingComponent) {
      this.housingHasChanged =
        this.housingComponent?.policyAddressHasChanged ||
        this.housingComponent?.policyAddressComplementHasChanged ||
        this.housingComponent?.policyZipCodeHasChanged ||
        this.housingComponent?.policyCityHasChanged ||
        this.housingComponent?.natureResidenceHasChanged ||
        this.housingComponent?.qualiteOccupantHasChanged ||
        this.housingComponent?.typeHabitationHasChanged ||
        this.housingComponent?.nombrePiecesHasChanged ||
        this.housingComponent?.nombrePiecesQuaranteHasChanged ||
        this.housingComponent?.surfaceDependanceHasChanged ||
        this.housingComponent?.possedePiscineHasChanged ||
        this.housingComponent?.possedeVerandaHasChanged ||
        this.housingComponent?.possedeEnergieVHasChanged ||
        this.housingComponent?.etageHasChanged;
    }
  }

  checkChildrenChanged() {
    if (this.childrenComponent) {
      this.childrenHasChanged =
        this.childrenComponent?.childLastNameHasChanged.some(x => x) ||
        this.childrenComponent?.childFirstNameHasChanged.some(x => x) ||
        this.childrenComponent?.childBirthDateHasChanged.some(x => x) ||
        this.childrenComponent?.childrenInformations.length !== this.childrenInformationsInitialValue.length;
    }
  }

  checkLessorChanged() {
    if (this.lessorComponent) {
      this.lessorHasChanged =
        this.lessorComponent?.lessorMailHasChanged ||
        this.lessorComponent?.lessorNameHasChanged ||
        this.lessorComponent?.lessorTypeHasChanged ||
        this.lessorComponent?.lessorDataNameHasChanged ||
        this.lessorComponent?.localPrincipalHasChanged ||
        this.lessorComponent?.houseIsOccupedHasChanged ||
        this.lessorComponent?.referenceClientHasChanged ||
        this.lessorComponent?.lessorMailSendDateHasChanged;
    }
  }

  checkPaymentChanged() {
    if (this.paymentComponent) {
      this.paymentHasChanged =
        this.paymentComponent?.paymentIbanHasChanged ||
        this.paymentComponent?.paymentOwnerHasChanged ||
        this.paymentComponent?.paymentMethodHasChanged ||
        this.paymentComponent?.paymentFractionationHasChanged ||
        this.paymentComponent?.paymentCollectionDateHasChanged;
    }
  }

  checkPersonalDataChanged() {
    if (this.personalDataComponent) {
      this.personalDataHasChanged =
        this.personalDataComponent?.cityHasChanged ||
        this.personalDataComponent?.emailHasChanged ||
        this.personalDataComponent?.zipCodeHasChanged ||
        this.personalDataComponent?.address1HasChanged ||
        this.personalDataComponent?.nationalityHasChanged ||
        this.personalDataComponent?.birthZipCodeHasChanged ||
        this.personalDataComponent?.address2HasChanged ||
        this.personalDataComponent?.civilityHasChanged ||
        this.personalDataComponent?.lastNameHasChanged ||
        this.personalDataComponent?.birthCityHasChanged ||
        this.personalDataComponent?.birthCountryHasChanged ||
        this.personalDataComponent?.phoneNumberHasChanged ||
        this.personalDataComponent?.phonePrefixHasChanged ||
        this.personalDataComponent?.emailConsentHasChanged ||
        this.personalDataComponent?.smsConsentHasChanged ||
        this.personalDataComponent?.memberBirthDateHasChanged ||
        this.personalDataComponent?.firstNameHasChanged;
    }
  }

  onSignaturePhonePrefixChange(event: { phonePrefix: PhonePrefixes; phoneMask: string }) {
    this.selectedSignaturePhonePrefix = event.phonePrefix;
    this.selectedPhoneMask = event.phoneMask;
    this.setIsFormValid(2);
  }

  onSignaturePhoneNumberChange(phoneNumber: string) {
    this.selectedSignaturePhoneNumber = phoneNumber;
    this.setIsFormValid(2);
  }

  onSignaturePhoneSignatureCheckBoxChange(checked: boolean) {
    this.savePhone = checked;
    this.setIsFormValid(2);
  }

  onNatureLogementChange($event: string) {
    this.natureLogement = $event;
  }

  onQualiteOccupantChange($event: string) {
    this.qualiteOccupant = $event;
    this.forOptTarifComponent.updateAttestationBailleur($event);
  }

  onNombrePieceChange($event: string) {
    this.nombrePieces = $event;
    this.updateCapitalMobilierAndValuableObject();
  }

  onNombrePiecesQuaranteChange($event: string) {
    this.nombrePiecesQuarante = $event;
    this.updateCapitalMobilierAndValuableObject();
  }

  updateCapitalMobilierAndValuableObject() {
    let nombrePiecesAsNumber = 0;
    let nombrePiecesAsNumberQuaranteAsNumber = 0;

    if (this.nombrePieces) {
      nombrePiecesAsNumber = +this.nombrePieces;
    }

    if (this.nombrePiecesQuarante) {
      nombrePiecesAsNumberQuaranteAsNumber = +this.nombrePiecesQuarante;
    }

    const nombrePiecesTotal = nombrePiecesAsNumber + nombrePiecesAsNumberQuaranteAsNumber;
    this.forOptTarifComponent.updateCapitalMobilier(nombrePiecesTotal.toString());

    if (!this.isConfort) {
      this.forOptTarifComponent.updateValuableObject(nombrePiecesTotal.toString());
    }
  }

  onSurfaceDependanceChange($event: string) {
    this.surfaceDependance = $event;
  }

  onPossedeVerandaChange($event: string) {
    this.possedeVeranda = $event;
  }

  onPossedeEnergieVChange($event: string) {
    this.possedeEnergieV = $event;
  }

  onPossedePiscineChange($event: string) {
    this.possedePiscine = $event;
  }

  onFormValidityChange($event: number) {
    this.setIsFormValid($event);
  }

  onPhoneMaskChange($event: string) {
    this.phoneMask = $event;
  }

  onCountryHasChange(event: number) {
    this.birthCountryId = event;
  }

  onPhoneNumberHasChange(event: string) {
    this.selectedSignaturePhoneNumber = event;
  }

  onPhonePrefixHasChange(event: PhonePrefixes) {
    this.selectedPhonePrefix = event;
    this.selectedSignaturePhonePrefix = event;
  }

  onChildrenInformationChange(event: RiskItemInformationsVm[]) {
    this.updateChildrenInformation(event);
  }

  onFormValiditySAChange(event: { isValid: boolean; values: { key: string; value: string }[] }) {
    event.isValid ? this.setIsFormValid(0) : null;
    this.identificationNumber = event.values.find(x => x.key === "identificationNumber")?.value ?? "";
  }

  updateChildrenInformation(value: RiskItemInformationsVm[]) {
    this.childrenInformations = value;
    this.reorderChildrenInformations();

    this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.RCS
    )!.riskItemValues = value;

    if (this.childrenInformations.length === 0) {
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.RCS)!.isSelected =
        false;
      this.isSchoolInsuranceSelected = false;
      this.forOptTarifComponent.updateRCSHasChanged();
    }
  }

  setClassActive(value: boolean): string {
    return value ? "active" : "inactive";
  }

  onShow() {}

  computeSignatureData() {
    if (
      (_.isNil(this.member.phonePrefix) && _.isNil(this.member.phoneNumber)) ||
      this.member.phoneNumber !== this.selectedSignaturePhoneNumber ||
      this.member.phonePrefix !== this.selectedSignaturePhonePrefix.prefix
    ) {
      this.displaySignaturePhone = true;
    }
  }

  computeChanges() {
    this.computeSignatureData();
    const computeUpdatePolicyCommand = this.toComputePolicyUpdateCommand();
    this.policyService.computePolicyUpdate(computeUpdatePolicyCommand).subscribe({
      next: (data: PolicyChangeLog) => {
        this.policyChangeLog = data;
        this.previousStep = this.activeIndex;
        this.activeIndex++;
      },
      error: resContract => {
        if (resContract.error?.status === HttpErrors.BadRequest) {
          this.IsCallInErrorDialogVisible = true;
        }
        if (resContract.error?.status === HttpErrors.UnprocessableEntity) {
          this.IsIbanInvalidDialogVisible = true;
        }
      },
    });
  }

  updatePolicy() {
    this.loading = true;
    const updatePolicyCommand = this.toUpdatePolicyCommand();
    this.policyService.updatePolicy(updatePolicyCommand).subscribe({
      next: () => {
        this.loading = false;
        this.redirect();
      },
      error: () => {
        this.loading = false;
        this.emitUpdateValidation.emit(false);
        this.IsCallInErrorDialogVisible = true;
      },
    });
  }

  redirect() {
    this.policyService.getPolicyWait4SignEndorsement().subscribe({
      next: policies => {
        if (policies.length > 0) {
          this.policyRecoveryService.getSignatureUrls(policies);
        } else {
          this.emitUpdateValidation.emit(true);
        }
        this.close();
      },
      error: () => {
        this.IsCallInErrorDialogVisible = true;
      },
    });
  }

  close() {
    this.dialogEmitter.emit(false);
  }

  validateStep() {
    if (this.activeIndex === this.getCurrentStep(1)) {
      this.computeChanges();
    }
    if (this.activeIndex === this.getCurrentStep(2)) {
      this.updatePolicy();
      this.previousStep = this.activeIndex;
      return;
    }
    if (this.activeIndex !== this.getCurrentStep(1)) {
      this.previousStep = this.activeIndex;
      this.activeIndex++;
    }
  }

  onBailleurHasChanged(event: boolean) {
    if (this.lessorDataCopy) {
      this.lessorDataCopy.isSelected = this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption;
    }

    this.bailleurHasChanged = event;
    if (
      this.bailleurHasChanged &&
      this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
      this.previousStep !== 1
    ) {
      this.isLessorDialogVisible = true;
    }
  }

  onLessorDialogClose(lessorData: LessorDataDto | null) {
    if (!lessorData) {
      this.isLessorDialogVisible = false;
      this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption = false;
      this.bailleurHasChanged = false;
      return;
    }

    this.lessorSocialSelected = lessorData.lessorType === LessorType.Social;
    this.isLessorDialogVisible = false;
    this.lessorData = lessorData;
    this.lessorDataCopy = structuredClone(lessorData);
    this.setIsFormValid(0);
  }

  onPaymentIbanBlur() {
    this.isIbanDialogVisible = true;
    this.setIsFormValid(0);
  }

  onIbanDialogClose(event: { validate: boolean; isOwner: boolean; isAll: boolean }) {
    if (event.validate) {
      this.applyToAllMyContracts = event.isAll;
    }
    if (!event.isOwner) {
      this.isIbanErrorDialogVisible = true;
      this.policyDetailsCopy.bankInformationPolicyVm.iban = "";
    }
    this.isIbanDialogVisible = false;
    this.setIsFormValid(0);
  }

  cancelStep() {
    this.previousStep = this.activeIndex;
    if (this.activeIndex === 0) {
      this.IsSaveDialogVisible = true;
    } else {
      this.activeIndex--;
    }
  }

  toUpdatePolicyCommand(): UpdatePolicyCommand {
    if (this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption) {
      this.lessorDataCopy.isSelected = true;
    }

    this.convertChildrenInformationDateToUTC();

    let obj: UpdatePolicyCommand = {
      policyId: this.policyId,
      valuableItem: this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value,
      formula: {
        formulaId: this.formula?.id ?? -1,
        formulaCode: this.formula?.code ?? "",
      },
      memberData: {
        birthZipCode: this.memberCopy.birthZipCode,
        nationality: this.nationalityId,
        civilityTypeId: this.memberCopy.civilityId,
        lastName: this.memberCopy.lastName,
        firstName: this.memberCopy.firstName,
        birthCity: this.memberCopy.birthCity,
        birthCountry: this.birthCountryId,
        birthDate: fromDateTimeToDateOnly(this.memberCopy.birthDate),
        address1: this.memberCopy.address1,
        address2: this.memberCopy.address2,
        zipCode: this.memberCopy.zipCode,
        city: this.memberCopy.addressCity,
        email: this.memberCopy.email,
        phonePrefix: this.selectedPhonePrefix?.prefix,
        cellPhone: this.memberCopy.phoneNumber,
        gdaTypeId: this.memberCopy.gdaTypeId === 0 ? null : this.memberCopy.gdaTypeId,
        isDematerializedPreferred: this.memberCopy.isDematerializationPreferred,
        isEmailConsents: this.memberCopy.isEmailConsents,
        isSmsConsents: this.memberCopy.isSmsConsents,
      },
      residentialRiskItemFields: {
        addressComplement: this.policyDetailsCopy.addressCompl,
        residenceType: this.natureLogement,
        occupierQuality: this.qualiteOccupant,
        numberOfRoom: this.nombrePieces,
        numberOfRoomGreaterThan40: this.nombrePiecesQuarante,
        floorNumber: this.policyDetailsCopy.riskItemInformations.values.find(
          x => x.code === this.riskItemInfo.ADR_ETAGE
        )?.value,
        dependenceArea: this.surfaceDependance,
        hasGreenPowerFacility: this.possedeEnergieV,
        hasPorch: this.possedeVeranda,
        hasSwimmingPool: this.possedePiscine,
      },
      options: this.policyDetailsCopy.formulasAndOptionsInformations.options,
      lessorData: this.lessorDataCopy,
      bankInformation: {
        iban: this.policyDetailsCopy.bankInformationPolicyVm.iban,
        fractionationTypeId: this.fractionationOptions.find(
          x => x.code === this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel
        )?.value,
        collectionDay: +this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay,
        paymentMethodId: 1,
        applyToAllMyContracts: this.applyToAllMyContracts,
      },
      signatureData: {
        phonePrefix: this.selectedSignaturePhonePrefix.prefix,
        cellPhone: this.selectedSignaturePhoneNumber,
        savePhone: this.savePhone,
      },
    };
    if (this.identificationNumber) {
      obj = { ...obj, animalRiskItemFields: { animalID: this.identificationNumber } };
    }
    return obj;
  }

  onNationalityHasChange(event: number) {
    this.nationalityId = event;
  }

  toComputePolicyUpdateCommand(): ComputePolicyUpdateCommand {
    if (this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption) {
      this.lessorDataCopy.isSelected = true;
    }

    if (!this.birthCountryId) {
      this.birthCountryId = this.countriesOptions.find(x => x.countryNameFr === this.memberCopy.birthCountry)!.id;
    }
    if (!this.nationalityId) {
      this.nationalityId = this.countriesOptions.find(x => x.countryNameFr === this.memberCopy.nationality)!.id;
    }

    this.convertChildrenInformationDateToUTC();

    let obj: ComputePolicyUpdateCommand = {
      policyId: this.policyId,
      valuableItem: this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value,
      formula: {
        formulaId: this.formula?.id ?? -1,
        formulaCode: this.formula?.code ?? "",
      },
      memberData: {
        birthZipCode: this.memberCopy.birthZipCode,
        nationality: this.nationalityId,
        civilityTypeId: this.memberCopy.civilityId,
        lastName: this.memberCopy.lastName,
        firstName: this.memberCopy.firstName,
        birthCity: this.memberCopy.birthCity,
        birthCountry: this.birthCountryId,
        birthDate: fromDateTimeToDateOnly(this.memberCopy.birthDate),
        address1: this.memberCopy.address1,
        address2: this.memberCopy.address2,
        zipCode: this.memberCopy.zipCode,
        city: this.memberCopy.addressCity,
        email: this.memberCopy.email,
        phonePrefix: this.selectedPhonePrefix?.prefix,
        cellPhone: this.memberCopy.phoneNumber,
        gdaTypeId: this.memberCopy.gdaTypeId === 0 ? null : this.memberCopy.gdaTypeId,
        isDematerializedPreferred: this.memberCopy.isDematerializationPreferred,
        isEmailConsents: this.memberCopy.isEmailConsents,
        isSmsConsents: this.memberCopy.isSmsConsents,
      },
      residentialRiskItemFields: {
        addressComplement: this.policyDetailsCopy.addressCompl,
        residenceType: this.natureLogement,
        occupierQuality: this.qualiteOccupant,
        numberOfRoom: this.nombrePieces,
        numberOfRoomGreaterThan40: this.nombrePiecesQuarante,
        floorNumber: this.policyDetailsCopy.riskItemInformations.values.find(
          x => x.code === this.riskItemInfo.ADR_ETAGE
        )?.value,
        dependenceArea: this.surfaceDependance,
        hasGreenPowerFacility: this.possedeEnergieV,
        hasPorch: this.possedeVeranda,
        hasSwimmingPool: this.possedePiscine,
      },
      options: this.policyDetailsCopy.formulasAndOptionsInformations.options,
      lessorData: this.lessorDataCopy,
      bankInformation: {
        iban: this.policyDetailsCopy.bankInformationPolicyVm.iban,
        fractionationTypeId: this.fractionationOptions.find(
          x => x.code === this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel
        )?.value,
        collectionDay: +this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay,
        paymentMethodId: 1,
        applyToAllMyContracts: this.applyToAllMyContracts,
      },
    };

    if (this.identificationNumber) {
      obj = { ...obj, animalRiskItemFields: { animalID: this.identificationNumber } };
    }
    return obj;
  }

  onIsIbanErrorDialogClose() {
    this.isIbanErrorDialogVisible = false;
  }

  onIsIbanInvalidDialogClose() {
    this.IsIbanInvalidDialogVisible = false;
  }

  onCallInErrorDialogVisible() {
    this.IsCallInErrorDialogVisible = false;
  }

  onSaveDialogClose(event: boolean) {
    this.IsSaveDialogVisible = false;
    if (event) {
      this.close();
    }
  }

  convertChildrenInformationDateToUTC() {
    const childrenInformationCopy = JSON.parse(JSON.stringify(this.childrenInformations)) as RiskItemInformationsVm[];
    childrenInformationCopy.forEach(x => {
      x.values = x.values.map(y => {
        if (y.code === this.ForOptTarif.DATE_ENFANT) {
          let dt = DateTime.fromISO(y.value).setLocale("fr");
          if (!dt.isValid) {
            dt = DateTime.fromFormat(y.value, "dd/MM/yyyy").setLocale("fr");
          }
          const formatted = dt.toFormat("dd/MM/yyyy");
          y.value = formatted;
        }
        return y;
      });
    });

    const rcsOption = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.RCS
    );
    if (rcsOption) {
      rcsOption.riskItemValues = childrenInformationCopy;
    }
  }
}
